import React from "react";
import "./teamInfo.scss";
import { FaBullhorn } from "react-icons/fa"; // bullhorn icon for branding

const Branding = () => (
  <div className="team__info flex-center">
    <div style={{ textAlign: "center" }}>
      <FaBullhorn size={40} style={{ marginBottom: "10px", color: "#333" }} />
      <h4 className="font20 weight800">Branding</h4>
      <p className="font12 weight500">
        Discover how we can enhance your brand identity and make it synonymous with the excitement and passion of football. Our branding strategies will set you apart from the competition.
      </p>
    </div>
  </div>
);

export default Branding;
